module.exports = __webpack_public_path__ + "static/share-888d6fb26f22940ebecd739a381a9797.jpg";